<div class="income-predictor-report">
  <PageControl
    :title="'Income Predictor Report'"
    :elements_query="sheet_elements"
  >
    <button
      class="btn btn-bg-green text-xs rounded-small shadow-sm me-2"
      @click="show_export_modal"
    >
      <i class="fas fa-download me-1"></i> Export Data
    </button>

    <!-- Export Modal -->
    <Teleport to="body">
      <div
        class="modal fade"
        :id="'export-modal-' + report_reference"
        tabindex="-1"
        aria-labelledby="exportModalLabel"
        aria-hidden="true"
      >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-4 shadow">
          <div class="modal-header">
            <h6 class="modal-title fw-semibold text-muted">
              Export Income Predictor Report Data
            </h6>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label fw-bold">Select Data to Export:</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="export_options.income_prediction" id="income_prediction">
                <label class="form-check-label" for="income_prediction">
                  Income Prediction
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="export_options.raw_json" id="raw_json">
                <label class="form-check-label" for="raw_json">
                  Raw JSON Data
                </label>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label fw-bold">Export Format:</label>
              <div class="form-check">
                <input class="form-check-input" type="radio" v-model="export_format" value="csv" id="csv">
                <label class="form-check-label" for="csv">
                  CSV
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" v-model="export_format" value="excel" id="excel">
                <label class="form-check-label" for="excel">
                  Excel
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" v-model="export_format" value="json" id="json">
                <label class="form-check-label" for="json">
                  JSON
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-bg-secondary text-xs rounded-small shadow-sm me-2"
              @click="close_modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-bg-green text-xs rounded-small shadow-sm"
              @click="export_data"
              :disabled="!has_selected_tables"
            >
              <i class="fas fa-download me-1"></i>
              Export Data
            </button>
          </div>
        </div>
      </div>
    </div>
    </Teleport>
  </PageControl>

  <PageComponent>
    <SectionSheet>
      <div
        class="container-fluid py-2 header d-flex align-items-center justify-content-between border-bottom mb-2"
      >
        <div class="d-flex">
          <img
            class="logo"
            width="295"
            height="125"
            src="@/assets/images/new_black_logo2.svg"
            alt="Logo"
          />
        </div>
        <div class="d-flex text-end">
          <div>
            <div class="h4 fw-bold mb-1">Income Predictor Report</div>
            <div class="text-muted text-xs">
              28 Fricker Rd,<br />
              Illovo, Johannesburg,<br />
              2196 South Africa<br />
              Website:
              <a
                >www.goodpeopledata.com</a
              >
            </div>
          </div>
        </div>
      </div>

      <hr class="my-3 border-dark">

      <div class="card shadow-sm p-2 bg-white mb-2">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-chart-line me-2"></i>
            Income Prediction Summary
          </h6>
        </div>
        <div class="card-body">
          <p class="mb-3">
            This report summarizes the income prediction for ID Number:
            <span class="fw-bold text-dark">{{ id_number }}</span>.
            The predicted GMIP value is <span class="fw-bold text-dark">{{ gmip_value }}</span>
            with a confidence level of <span class="fw-bold text-dark">{{ gmip_confidence_level }}</span>.
          </p>
        </div>
      </div>

      <!-- Report Header -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-info-circle me-2"></i>
                Prediction Details
              </h6>
              <div class="text-muted small">
                Generated on {{ formatted_generation_date }}
              </div>
            </div>
            <div class="card-body">
              <table class="table table-sm table-borderless report-table">
                <tbody>
                  <tr>
                    <td class="label-modern">ID Number</td>
                    <td class="fw-bold">{{ id_number }}</td>
                  </tr>
                  <tr>
                    <td class="label-modern">GMIP Value</td>
                    <td class="fw-bold">{{ gmip_value }}</td>
                  </tr>
                  <tr>
                    <td class="label-modern">Confidence Level</td>
                    <td class="fw-bold">{{ gmip_confidence_level }}</td>
                  </tr>
                  <tr>
                    <td class="label-modern">GMIP Band</td>
                    <td class="fw-bold">{{ gmip_band }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ report_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_generation_date }}
        </div>
      </div>
    </SectionSheet>

    <SectionSheet>
      <div class="card shadow-sm">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-exclamation-triangle me-2"></i>
            Disclaimer
          </h6>
        </div>
        <div class="card-body">
          <div class="disclaimer-content">
            <h6 class="mb-3 border-bottom pb-2">
              <i class="bi bi-info-circle me-2"></i>General Information
            </h6>
            <p class="text-xs mb-4">
              This Income Predictor Report is prepared solely for the benefit
              of the intended recipient and is based on data obtained from authorized sources.
              While <strong> THE GOOD PEOPLE DATA COMPANY (PTY) LTD ('TGPDC')
                </strong> employs industry-standard practices to collect and process information,
              TGPDC does not guarantee, and expressly disclaims, the accuracy, completeness
              or reliability of the information contained herein.
            </p>
            <h6 class="mb-3 border-bottom pb-2">
              <i class="bi bi-shield-check me-2"></i>Limitations
            </h6>
            <p class="text-xs mb-4">
              The income prediction is based on historical data and predictive models.
              Actual income may vary due to various factors.
            </p>
            <div class="text-center text-muted mt-3">
              <i class="fas fa-lock me-2"></i>
              This report is confidential and intended for the recipient only.
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ report_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_generation_date }}
        </div>
      </div>
    </SectionSheet>
  </PageComponent>
</div>
